var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExclamation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 19,
    viewBox: "0 0 21 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1319_1709)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.5098 1.33789L20.0879 14.541C20.332 14.9707 20.4688 15.4492 20.4688 15.9082C20.4688 17.4023 19.4629 18.5547 17.8027 18.5547H2.66602C1.00586 18.5547 0 17.4023 0 15.9082C0 15.4492 0.117188 14.9805 0.380859 14.541L7.95898 1.33789C8.45703 0.449219 9.33594 0 10.2344 0C11.1328 0 12.002 0.449219 12.5098 1.33789ZM9.15039 14.2578C9.15039 14.834 9.6582 15.3027 10.2441 15.3027C10.8203 15.3027 11.3281 14.8438 11.3281 14.2578C11.3281 13.6621 10.8301 13.2031 10.2441 13.2031C9.64844 13.2031 9.15039 13.6719 9.15039 14.2578ZM9.31641 5.9082L9.44336 11.2207C9.45312 11.7383 9.73633 12.0312 10.2441 12.0312C10.7227 12.0312 11.0059 11.748 11.0156 11.2207L11.1621 5.91797C11.1719 5.40039 10.7617 5.01953 10.2344 5.01953C9.6875 5.01953 9.30664 5.39062 9.31641 5.9082Z",
    fill: "#CD201F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1319_1709"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20.8301,
    height: 18.6621,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExclamation);
export default __webpack_public_path__ + "static/media/exclamation.5d70b4fc423c5482ea14de37eeced72a.svg";
export { ForwardRef as ReactComponent };